import { useAccountStore } from "@/stores/account"
import { useEstablishmentStore } from "@/stores/establishment"

export const waitForEstablishments = async (timeoutMs = 10000): Promise<void> => {
  const accountStore = useAccountStore()

  if (accountStore.establishmentLoaded && accountStore.establishments.length > 0) {
    return
  }

  await Promise.race([
    new Promise<void>((resolve) => {
      const result = accountStore.getEstablishments(() => {
        accountStore.establishmentLoaded = true
        resolve()
      }, false)

      if (!result) {
        resolve()
      }
    }),
    new Promise<void>((resolve) => {
      window.setTimeout(resolve, timeoutMs)
    }),
  ])

  accountStore.establishmentLoaded = true
}

/**
 * Charge le détail établissement (dont local_diffusers) avant le garde assistant local.
 * Sur F5, le store persisté peut ne pas encore contenir les diffuseurs TIC.
 */
export const ensureLocalAssistantRouteContext = async (timeoutMs = 10000): Promise<void> => {
  await waitForEstablishments(timeoutMs)

  const accountStore = useAccountStore()
  const establishmentStore = useEstablishmentStore()

  const requestedEstablishmentId = Number(sessionStorage.getItem("requestedEstablishmentId"))
  let establishmentId =
    establishmentStore.currentEstablishment?.id ||
    (Number.isFinite(requestedEstablishmentId) ? requestedEstablishmentId : undefined) ||
    accountStore.establishments[0]?.id

  if (!establishmentId) {
    await Promise.race([
      new Promise<void>((resolve) => {
        establishmentStore.initEstablishment(undefined, () => resolve())
      }),
      new Promise<void>((resolve) => window.setTimeout(resolve, timeoutMs)),
    ])
    return
  }

  await Promise.race([
    establishmentStore.getCurrentEstablishment(Number(establishmentId)),
    new Promise<void>((resolve) => window.setTimeout(resolve, timeoutMs)),
  ])

  establishmentStore.syncLocalDiffuserBranding()
}
